import axios from "axios"
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { getId, getToken, usePermissions } from "../../user/User"
import BasicTableComponent, { NumberRangeColumnFilter, SelectColumnFilter } from "../../components/basic.table"
import { toast } from "react-toastify"

const AutomaticMailingList = () => {
    const navigate = useNavigate()

    const { permissions } = usePermissions(getId())
    useEffect(() => {
        if(permissions.client !== undefined && !permissions.client) {
            toast.error("You don't have permission to view automatic mailings!")
            navigate("/")
        }
    }, [permissions])

    const handleCreate = async e => {
        e.preventDefault(),
        navigate("/automaticmailing/create")
    }

    const columns =  [{
        Header: "Id",
        accessor: "id",
        Filter: NumberRangeColumnFilter,
        filter: 'between'
    }, {
        Header: "Recipient",
        accessor: "recipient",
        Filter: SelectColumnFilter,
        filter: 'includes'
    }, {
        Header: "Mail template",
        accessor: "mail_template_name",
        Filter: SelectColumnFilter,
        filter: 'includes'
    }, {
        Header: "Provider",
        accessor: "provider_name",
        Filter: SelectColumnFilter,
        filter: 'includes'
    }, {
        Header: "Duration",
        accessor: "duration",
        Filter: NumberRangeColumnFilter,
        filter: 'between'
    }, {
        Header: "Days until expiry",
        accessor: "days_until_expiry",
        Filter: NumberRangeColumnFilter,
        filter: 'between'
    }, {
        Header: "Edit",
        UrlPart: "automaticmailing"
    }, {
        Header: "Delete",
        UrlPart: "automaticmailing/delete"
    }]

    const [automaticMailings, setAutomaticMailings] = useState([])

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + "/api/automaticmailings", {
            headers: {
                "Authorization": "Bearer " + getToken()
            }
        })
        .then(res => {
            if(res.data === null || res.data === "") {
                return
            }
            setAutomaticMailings(res.data)
        }).catch(_ => {
            toast.error("Unable to load automatic mailings!")
        })
    }, [])

    return (
        <div>
            <button className="btn btn-primary" onClick={handleCreate}>Create automatic mailing</button>

            <BasicTableComponent columns={columns} data={automaticMailings} />
        </div>
    )
}

export default AutomaticMailingList